import { Component } from '@theme/component';
import { DialogOpenEvent } from '@theme/dialog';

/** Uses Shopify's presentment exchange rate; totals are refreshed by cart section hydration. */
class LabooshDeliveryStatus extends Component {
  static observedAttributes = ['data-total', 'data-currency'];
  #drawer;
  #refresh = () => this.render();
  connectedCallback() {
    super.connectedCallback();
    this.#drawer=this.closest('cart-drawer-component');
    this.#drawer?.addEventListener(DialogOpenEvent.eventName,this.#refresh);
    queueMicrotask(() => this.render());
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.#drawer?.removeEventListener(DialogOpenEvent.eventName,this.#refresh);
  }
  updatedCallback() { super.updatedCallback(); this.render(); }
  attributeChangedCallback() { if (this.isConnected) queueMicrotask(() => this.render()); }
  render() {
    const title=this.querySelector('.laboosh-delivery__title');
    const fill=this.querySelector('.laboosh-delivery__fill');
    const note=this.querySelector('.laboosh-delivery__note');
    if (!title || !fill || !note) return;
    const currency=this.dataset.currency;
    const rate=currency==='AED' ? 1 : (window.Shopify?.currency?.active===currency ? Number(window.Shopify.currency.rate) : NaN);
    const total=Number(this.dataset.total);
    if(this.dataset.country!=='AE' && (!(rate>0) || !Number.isFinite(total))) return;
    const threshold=Math.ceil(60000*rate);
    const remaining=Math.max(0,threshold-total);
    const active=this.dataset.country==='AE' || remaining===0;
    const amount=new Intl.NumberFormat(document.documentElement.lang||'en',{style:'currency',currency,minimumFractionDigits:2,maximumFractionDigits:2}).format(remaining/100);
    title.textContent=active ? this.dataset.active : this.dataset.remaining.replace('__AMOUNT__',amount);
    note.textContent=active ? this.dataset.note : this.dataset.thresholdNote;
    fill.style.setProperty('--delivery-progress',active?'100%':Math.min(100,Math.max(0,total/threshold*100))+'%');
  }
}
if(!customElements.get('laboosh-delivery-status')) customElements.define('laboosh-delivery-status',LabooshDeliveryStatus);
